import { render, staticRenderFns } from "./TemplateAccidentReportIndex.vue?vue&type=template&id=6a848f78&scoped=true&"
import script from "./TemplateAccidentReportIndex.vue?vue&type=script&lang=js&"
export * from "./TemplateAccidentReportIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a848f78",
  null
  
)

export default component.exports